import React, { useState } from "react";
import { FaSignOutAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom"; 
import MySwal from 'sweetalert2'; 
import logoHorizontal from "../img/fondo-horizontal.svg";
import { MdLogout } from "react-icons/md";
export const Header = () => {
  const navigate = useNavigate();
  
  const logout = async (e) => {
    e.preventDefault();
    // Aquí puedes descomentar y ajustar tu lógica de cierre de sesión como lo tienes
    // const logearse = await axios.get(URI, { 
    //   withCredentials: true, 
    //   credentials: "include",
    //   headers: {
    //     "Access-Control-Allow-Origin": "*",
    //     "Content-Type": "application/json",
    //   },
    // });

    // Si la respuesta es correcta, mostrar el mensaje de alerta y redirigir al login
  //   MySwal.fire({
  //     text: "Sesión finalizada",
  //     imageHeight: 65,
  //     confirmButtonText: "Ok",
  //     customClass: {
  //       confirmButton: 'btn-confirmar', 
  //  }
  //   });
    
    // Eliminar la sesión del localStorage
    localStorage.removeItem("camulabo_valid_session");

    // Redirigir a la página principal
    navigate("/");
  };

  return (
    <header className="header">
      <div className="logo">
        <img src={logoHorizontal} alt="Logo" />
      </div>
      <div className="logout" onClick={logout}>
        <MdLogout className="logout-icon" />
        <span className="cerrar-sesion">Cerrar sesión</span>
      </div>
    </header>
  );
};
